import { Theme, styled } from '@material-ui/core';
import { DeviceType } from 'src/modules/shared/hooks/useDeviceType';

export const TrajectoryToolboxWrapper = styled('div')<
  Theme,
  { sidepanelwidth?: number | string; presentationmode?: boolean; device: DeviceType }
>(({ theme, sidepanelwidth, presentationmode, device }) => ({
  position: 'fixed',
  top: presentationmode
    ? theme.config.subHeaderHeight
    : `${theme.config.appbarHeight + theme.config.subHeaderHeight}px`,
  right: 0,
  zIndex: 4,
  height: presentationmode
    ? `calc(100vh - ${theme.config.subHeaderHeight}px)`
    : `calc(100vh - ${theme.config.appbarHeight + theme.config.subHeaderHeight}px)`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.common.white,
  width: theme.config.trajectoryToolboxWidth,
  paddingTop: theme.spacing(2),
  paddingBottom: device === 'Tablet' ? theme.spacing(5) : theme.spacing(2),
  boxSizing: 'border-box',
  'body:has(#banner) &': {
    top: `${
      theme.config.appbarHeight + theme.config.subHeaderHeight + theme.config.messageBarHeight
    }px`,
    height: `calc(100vh - ${
      theme.config.appbarHeight + theme.config.subHeaderHeight + theme.config.messageBarHeight
    }px)`,
    [theme.breakpoints.down('xs')]: {
      top: `${theme.config.mobileMessageBarHeight}px`,
    },
  },
  '&.fullscreen': {
    top: `${theme.config.subHeaderHeight}px`,
    height: `calc(100vh - ${theme.config.subHeaderHeight}px)`,
  },
  '&.notes-panel-active': {
    right: 0,
    zIndex: 4,
    height: `calc(100dvh - ${theme.config.appbarHeight + theme.config.subHeaderHeight}px)`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.common.white,
    width: theme.config.trajectoryToolboxWidth,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    boxSizing: 'border-box',
    '&.fullscreen': {
      top: `${theme.config.subHeaderHeight}px`,
      height: `calc(100dvh - ${theme.config.subHeaderHeight}px)`,
    },
    '&.notes-panel-active': {
      right: 0,
    },
    '&.side-panel-active': {
      right: sidepanelwidth,
    },
    borderLeft: `1px solid ${theme.config.appbarColors.borderColor}`,
  },
}));

export const TrajectoryToolboxMenu = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  gap: '1rem',
});
